import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import {
  ABOUT_PRESIDENT,
  ARTE_Y_CULTURA_TEAM,
  LIBER_EDITORIAL_TEAM,
  ABOUT_BODY_HTML,
} from '../../core/data/about-data';

@Component({
  selector: 'app-about-us',
  imports: [],
  templateUrl: './about-us.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './about-us.scss',
})
export class AboutUs {
  protected readonly president = ABOUT_PRESIDENT;
  protected readonly arteYCulturaTeam = ARTE_Y_CULTURA_TEAM;
  protected readonly liberEditorialTeam = LIBER_EDITORIAL_TEAM;
  protected readonly bodyHtml: SafeHtml;

  constructor(sanitizer: DomSanitizer) {
    this.bodyHtml = sanitizer.bypassSecurityTrustHtml(ABOUT_BODY_HTML);
  }
}
